import { render, staticRenderFns } from "./CustomerNotificationsList.vue?vue&type=template&id=67935b87&scoped=true&"
import script from "./CustomerNotificationsList.vue?vue&type=script&lang=ts&"
export * from "./CustomerNotificationsList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerNotificationsList.vue?vue&type=style&index=0&id=67935b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67935b87",
  null
  
)

export default component.exports